export default __webpack_public_path__ + "static/media/element_spec_78.d229d17b.webp";